/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  Box,
  useMediaQuery,
  useTheme,
  Autocomplete,
  InputLabel,
} from '@mui/material';
import { RiArrowDownSLine } from 'react-icons/ri';
import { NewAutoCompleteMenu } from 'views/rebranded-module/common/components/UI/NewMainWidget';
import { TOUR_WIDGET_FIELDS } from 'lib/utils/mainWidgetConstants';
import StyledGrid, { StyledIconedBox } from 'views/rebranded-module/common/components/UI/NewMainWidget/NewTourWidget/NewTourWidget.styles';
import { NewMainWidgetTextField } from 'views/rebranded-module/common/components/UI/NewMainWidget/NewMainWidgetTextField';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const NewTourWidget = (props) => {
  const {
    vertical,
    countriesList,
    statesList,
    tourTypesList,
    handleSelectInputChange,
    selectedOptions,
    handleSearchButtonClick,
    renderAllWidget = true,
    handleRenderAllWidget = () => {},
  } = props;
  const cmsData = useContent('NewMainWidgetComponent');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [widgetMounted, setWidgetMounted] = useState(false);
  
  const getFieldValue = (options, selectedOptionField) => options.find(
    (option) => option.id == selectedOptions[selectedOptionField]?.id,
  ) || {};

  const handleFieldChange = async (fieldType, ...args) => {
    (document.activeElement as HTMLElement)?.blur();
    await handleSelectInputChange(fieldType, ...args);
    handleRenderAllWidget(true);
  };

  const renderInputField = (label: string, placeholder: string, params: any) => (
    <>
      <InputLabel className="WidgetInputLabel">{label}</InputLabel>
      <NewMainWidgetTextField
        {...params}
        placeholder={placeholder}
        variant="filled"
      />
    </>
  );

  useEffect(() => {
    setWidgetMounted(true);
  }, []);

  useEffect(() => {
    if (widgetMounted && !isMobile) handleRenderAllWidget(true);
  }, [widgetMounted]);

  return (
    <StyledGrid container rowSpacing={1.5} className="tourWidget">
      <Grid item xs={12} position="relative">
        <Box className="TWFieldContainer">
          <StyledIconedBox Icon={RiArrowDownSLine} className="TWInputField">
            <Autocomplete
              options={tourTypesList}
              getOptionLabel={(option) => option.name || ''}
              value={getFieldValue(tourTypesList, TOUR_WIDGET_FIELDS.TOUR_TYPE)}
              onChange={(...args) => handleFieldChange(TOUR_WIDGET_FIELDS.TOUR_TYPE, ...args)}
              className='WidgetInput'
              popupIcon={null}
              autoComplete
              disableClearable
              includeInputInList
              PaperComponent={NewAutoCompleteMenu}
              renderInput={(params) => renderInputField(cmsData.tourTypeLabel, cmsData.tourType, params)}
            />
          </StyledIconedBox>
        </Box>
      </Grid>
      <Grid container item spacing={1.5}>
        <Grid item xs={12} md={vertical ? 12 : 6} position="relative">
          <Box className="TWFieldContainer">
            <StyledIconedBox Icon={RiArrowDownSLine} className="TWInputField">
              <Autocomplete
                options={countriesList}
                getOptionLabel={(option) => option.name || ''}
                value={getFieldValue(countriesList, TOUR_WIDGET_FIELDS.COUNTRY)}
                onChange={(...args) => handleFieldChange(TOUR_WIDGET_FIELDS.COUNTRY, ...args)}
                className='WidgetInput'
                popupIcon={null}
                autoComplete
                disableClearable
                includeInputInList
                PaperComponent={NewAutoCompleteMenu}
                renderInput={(params) => renderInputField(cmsData.countryLabel, cmsData.country, params)}
              />
            </StyledIconedBox>
          </Box>
        </Grid>
        {renderAllWidget && (
          <>
            <Grid item xs={12} md={vertical ? 12 : 6} position="relative">
              <Box className="TWFieldContainer">
                <StyledIconedBox Icon={RiArrowDownSLine} className="TWInputField">
                  <Autocomplete
                    options={statesList}
                    getOptionLabel={(option) => option.name || ''}
                    autoComplete
                    includeInputInList
                    disableClearable
                    popupIcon={null}
                    className='WidgetInput'
                    value={getFieldValue(statesList, TOUR_WIDGET_FIELDS.STATE)}
                    onChange={(...args) => handleFieldChange(TOUR_WIDGET_FIELDS.STATE, ...args)}
                    PaperComponent={NewAutoCompleteMenu}
                    renderInput={(params) => renderInputField(cmsData.stateNameLabel, cmsData.stateName, params)}
                    renderOption={(optionProps, option) => (
                      <li {...optionProps} key={option.id}>
                        {option.name}
                      </li>
                    )}
                  />
                </StyledIconedBox>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
      <Grid item xs>
        <Button
          variant="contained"
          size="large"
          fullWidth
          disableElevation
          onClick={() => {
            if (renderAllWidget) handleSearchButtonClick();
            else handleRenderAllWidget(true);
          }}>
          {renderAllWidget
            ? cmsData.searchTour
            : cmsData.startYourReservation
            }
        </Button>
      </Grid>
    </StyledGrid>
  );
};

export { NewTourWidget };
